import React from "react"
import SmallPortal from "./SmallPortal"

export default function DayPanel(props){
    const tempUnit = () => {
        if(props.unit === "fahrenheit"){
            const fhitemp = Math.round(props.hitemp * (9/5) + 32)
            const flowtemp = Math.round(props.lowtemp * (9/5) + 32)
        return (`${fhitemp}° / ${flowtemp}°`)
        } else {
            return (`${props.hitemp}° / ${props.lowtemp}°`)
        }
    }

    const date = () => {
        var weekData = {
            1: "Mon",
            2: "Tue",
            3: "Wed",
            4: "Thu",
            5: "Fri",
            6: "Sat",
            0: "Sun",
        }
        const day = new Date(props.date*1000).getDay();
        const date = new Date(props.date*1000).getDate();
        const month = new Date(props.date*1000).getMonth() + 1;
        const todayDate = new Date().getDate();
        const todayMonth = new Date().getMonth() + 1;
        if (date === todayDate && month === todayMonth){
            return (`Today`)
        } else {
            return (`${weekData[day]} ${month}/${date}`)
        }        
    }


    return (
        <div className="indiv-panel">
            <div id="indiv-desc">
                <p>{props.weathermain}</p>
            </div>
            <SmallPortal 
                icon={props.icon}
                weathermain={props.weathermain}
                weatherdesc={props.weatherdesc}
            />
           <h2>{tempUnit()}</h2>
            <h4 id="indiv-date">{date()}</h4>
        </div>
    )

}